import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { FeaturesSection } from './components/FeaturesSection';
import { AboutSection } from './components/AboutSection';
import { TeamSection } from './components/TeamSection';
import { CaseStudiesSection } from './components/CaseStudiesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { CookieScriptLoader } from './components/CookieScriptLoader';
import { GoogleTagLoader } from './components/GoogleTagLoader';
export function App() {
  return <div className="w-full min-h-screen font-sans text-gray-900" data-id="element-0" data-mp="2wk9y4kb1ymz3">
      <CookieScriptLoader data-id="element-1" data-mp="2whxabqim5ie4" />
      <GoogleTagLoader data-id="element-2" data-mp="28u5zysgmvffh" />
      <Header data-id="element-3" data-mp="28te0v7ntuzkg" />
      <main data-id="element-4" data-mp="28t4j27cxrypu">
        <HeroSection data-id="element-5" data-mp="28sl48zil1qg1" />
        <FeaturesSection data-id="element-6" data-mp="28s2z1ddy01vz" />
        <CaseStudiesSection data-id="element-7" data-mp="23vuq4hqc94x9" />
        <AboutSection data-id="element-8" data-mp="23ujlkfp2jt53" />
        <TeamSection data-id="element-9" data-mp="23t8hsfvmildz" />
        <TestimonialsSection data-id="element-10" data-mp="3ijxo6nd1puib" />
        <ContactSection data-id="element-11" data-mp="3ikqytzf4l45q" />
      </main>
      <Footer data-id="element-12" data-mp="3ijpe138b53at" />
    </div>;
}